/** Mirrors backend/utils/sponsor_engagement_defaults.py for Restore Defaults. */
export const DEFAULT_SPONSOR_ENGAGEMENT_PROGRAM = {
  cycle_config: {
    cadence: "quarterly" as const,
    poll1_frequency: "quarterly" as const,
    poll2_frequency: "bi-quarterly" as const,
  },
  scoring_config: {
    leaderboard_weights: {
      health: 0.25,
      arr: 0.25,
      team: 0.25,
      activity: 0.25,
    },
    poll1_tiers: [
      { min: 7, max: 8, score_5pt: 5, tier: "Champion" },
      { min: 5, max: 6, score_5pt: 4, tier: "Active" },
      { min: 3, max: 4, score_5pt: 3, tier: "Developing" },
      { min: 1, max: 2, score_5pt: 2, tier: "Developing" },
      { min: 0, max: 0, score_5pt: 1, tier: "At-Risk" },
    ],
    poll2_tiers: [
      { min: 13, max: 15, score_5pt: 5, label: "Excellent" },
      { min: 10, max: 12, score_5pt: 4, label: "Good" },
      { min: 7, max: 9, score_5pt: 3, label: "Adequate" },
      { min: 4, max: 6, score_5pt: 2, label: "Needs Attention" },
      { min: 0, max: 3, score_5pt: 1, label: "Needs Attention" },
    ],
    arr_growth_bands: [
      { min_pct: 50, max_pct: null, score_5pt: 5 },
      { min_pct: 20, max_pct: 49, score_5pt: 4 },
      { min_pct: 5, max_pct: 19, score_5pt: 3 },
      { min_pct: -10, max_pct: 4, score_5pt: 2 },
      { min_pct: null, max_pct: -11, score_5pt: 1 },
    ],
    portfolio_tiers: [
      { min: 4.5, max: 5.0, tier: "Champion" },
      { min: 3.5, max: 4.4, tier: "Active" },
      { min: 2.5, max: 3.4, tier: "Developing" },
      { min: 0.0, max: 2.4, tier: "At-Risk" },
    ],
    streak_threshold: 3,
    gap_quadrant_threshold: 3,
    nudge_weeks_before: 6,
    late_window_grace_days: 14,
    show_rubric_to_sponsors: true,
  },
  poll1_evidence_config: [
    { id: "q1", evidence_type: "text", evidence_required: false },
    { id: "q2", evidence_type: "date", evidence_required: true },
    { id: "q3", evidence_type: "date", evidence_required: true },
    { id: "q4", evidence_type: "date", evidence_required: true },
  ],
  poll2_evidence_config: [
    { id: "involvement", evidence_type: "text" },
    { id: "relationship", evidence_type: "text" },
    { id: "knowledge", evidence_type: "text" },
  ],
  launch_defaults: {
    reminder_cadence: "weekly",
    target_audience: "all",
  },
};
